import { Sparkles, X } from "lucide-react";
import { toast } from "sonner";

import { Button, ScrollArea } from "@/components/ui";
import { VAULT_AI_SUGGESTIONS } from "@/mockData/vaultNav";

interface VaultAriPanelProps {
  onClose: () => void;
}

export function VaultAriPanel({ onClose }: VaultAriPanelProps) {
  return (
    <aside className="flex w-80 shrink-0 flex-col overflow-hidden border-l border-border">
      <div className="flex items-center justify-between border-b border-border px-4 py-3">
        <div className="flex items-center gap-2">
          <span className="">
            Ari Suggestions
          </span>
        </div>
        <Button variant="ghost" size="icon-sm" onClick={onClose} aria-label="Close Ari panel">
          <X className="size-4" />
        </Button>
      </div>

      <ScrollArea className="min-h-0 flex-1 p-3">
        <div className="space-y-2">
          {VAULT_AI_SUGGESTIONS.map((s) => (
            <div key={s.id} className="rounded-2xl bg-muted/50 p-3">
              <p className="text-sm font-medium text-foreground">{s.title}</p>
              <p className="mt-1 text-xs leading-relaxed text-muted-foreground">{s.detail}</p>
              <Button
                size="sm"
                variant="outline"
                className="mt-2 h-7 text-xs"
                onClick={() => toast.info(`${s.action} is coming soon`)}
              >
                {s.action} ({s.count})
              </Button>
            </div>
          ))}
        </div>
      </ScrollArea>
    </aside>
  );
}
